import {
  createContext,
  type FunctionComponent,
  type PropsWithChildren,
  useState,
} from "react";

import { createEmotionCache } from "./emotion-cache";

import { CacheProvider } from "@emotion/react";

export type ClientStyleContextData = {
  reset: () => void;
};

export const ClientStyleContext = createContext<ClientStyleContextData>({
  reset: () => {},
});

export const ClientCacheProvider: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const [cache, setCache] = useState(createEmotionCache());

  function reset() {
    setCache(createEmotionCache());
  }

  return (
    <ClientStyleContext.Provider value={{ reset }}>
      <CacheProvider value={cache}>{children}</CacheProvider>
    </ClientStyleContext.Provider>
  );
};

export type ServerStyleContextData = {
  key: string;
  ids: string[];
  css: string;
};

export const ServerStyleContext = createContext<
  ServerStyleContextData[] | null
>(null);
